import axios from 'axios'

export default {
  namespaced: true,
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
    loading: false,
    error: null
  },
  mutations: {
    SET_AUTH(state, { token, user }) {
      state.token = token
      state.user = user
      if (token) {
        localStorage.setItem('token', token)
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      } else {
        localStorage.removeItem('token')
        delete axios.defaults.headers.common['Authorization']
      }
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    CLEAR_AUTH(state) {
      state.token = null
      state.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      delete axios.defaults.headers.common['Authorization']
    }
  },
  actions: {
    async login({ commit, dispatch }, credentials) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await axios.post('/auth/login', credentials)
        const { token, user } = response.data
        
        if (!token) {
          throw new Error('Token non reçu du serveur')
        }
        
        commit('SET_AUTH', { token, user })
        
        localStorage.setItem('user', JSON.stringify(user))
        
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        
        try {
          await dispatch('getCurrentUser')
        } catch (error) {
          console.error('Erreur lors du chargement du profil:', error)
        }
        
        return response
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Erreur de connexion')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async logout({ commit }) {
      commit('CLEAR_AUTH')
    },
    async getCurrentUser({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await axios.get('/auth/me')
        const user = response.data
        commit('SET_USER', user)
        return response
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Erreur lors de la récupération du profil')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async getProfile({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await axios.get('/auth/me')
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Erreur lors de la récupération du profil')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async updateProfile({ commit }, profileData) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await axios.put('/auth/profile', profileData)
        commit('SET_USER', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Erreur lors de la mise à jour du profil')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async changePassword({ commit }, passwordData) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await axios.put('/auth/change-password', passwordData)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Erreur lors du changement de mot de passe')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    currentUser: state => state.user,
    isAdmin: state => state.user?.role === 'admin',
    isSuperAdmin: state => state.user?.role === 'super_admin',
    hasPermission: state => (permission) => {
      if (!state.user) return false
      if (state.user.role === 'super_admin') return true
      if (state.user.role === 'admin') {
        return ['manage_categories', 'manage_users'].includes(permission)
      }
      return false
    }
  }
} 